import React, { useState } from "react";
function SharedGPAPlanner() {
  const [currentGPA, setCurrentGPA] = useState(0);
  const [targetGPA, setTargetGPA] = useState(0);
  const [currentCredits, setCurrentCredits] = useState(0);
  const [additionalCredits, setAdditionalCredits] = useState(0);
  const [showResult, setShowResult] = useState(false);
  const [error, setError] = useState(null);
  const calculateRequiredGPA = () => {
    const requiredGPA =
      (targetGPA * (currentCredits + additionalCredits) -
        currentGPA * currentCredits) /
      additionalCredits;
    if (requiredGPA <= 4.0) {
      return (
        <div>
          Untuk mencapai IPK target yaitu <strong>{targetGPA}</strong>, IPK untuk
          <strong>{additionalCredits}</strong> SKS berikutnya harus
          <strong>{requiredGPA.toFixed(3)}</strong> atau lebih tinggi.
        </div>
      );
    } else {
      return (
        <div>
          Tidak mungkin mencapai IPK target dengan SKS yang diberikan dan IPK
          saat ini.
        </div>
      );
    }
  };
  const handleCalculateClick = () => {
    setShowResult(true);
    setError(null);
  };
  return (
    <div className="ltr" id="gpaPlannerContainer">
      <div className="row">
        <div className="col-sm-12 col-md-7 calculatorStyle">
          <div className="p-3 mb-2 bg-success text-white">
            <h2 style={{ fontSize: "16px" }} id="calculatorTitle">
              Kalkulator Perencanaan IPK
            </h2>
          </div>
          <hr />
          <div
            className="form-group d-flex align-items-center mb-2"
            id="currentGPAGroup"
          >
            <b>
              {" "}
              <label htmlFor="currentGPA">IPK Saat Ini:</label>
            </b>
            <input
              type="number"
              style={{ width: "30%", marginRight: "10px" }}
              value={currentGPA}
              onChange={(e) => setCurrentGPA(parseFloat(e.target.value))}
              className="form-control"
              step="0.01"
              id="currentGPA"
            />
          </div>
          <div
            className="form-group d-flex align-items-center  mb-2"
            id="targetGPAGroup"
          >
            <b>
              {" "}
              <label htmlFor="targetGPA">
                IPK yang Ingin Dicapai:
              </label>
            </b>
            <input
              type="number"
              style={{ width: "30%", marginRight: "10px" }}
              value={targetGPA}
              onChange={(e) => setTargetGPA(parseFloat(e.target.value))}
              className="form-control"
              step="0.01"
              id="targetGPA"
            />
          </div>
          <div
            className="form-group d-flex align-items-center  mb-2"
            id="currentCreditsGroup"
          >
            <b>
              {" "}
              <label htmlFor="currentCredits">Jumlah SKS yang Telah Ditempuh:</label>
            </b>
            <input
              type="number"
              style={{ width: "30%", marginRight: "10px" }}
              value={currentCredits}
              onChange={(e) => setCurrentCredits(parseFloat(e.target.value))}
              className="form-control"
              step="0.01"
              id="currentCredits"
            />
          </div>
          <div
            className="form-group d-flex align-items-center  mb-2"
            id="additionalCreditsGroup"
          >
            <b>
              {" "}
              <label htmlFor="additionalCredits">
                Jumlah SKS yang Akan Diambil:
              </label>
            </b>
            <input
              type="number"
              value={additionalCredits}
              onChange={(e) => setAdditionalCredits(parseFloat(e.target.value))}
              className="form-control"
              style={{ width: "30%", marginRight: "10px" }}
              step="0.01"
              id="additionalCredits"
            />
          </div>
          <button
            className="btn btn-success mt-3"
            onClick={handleCalculateClick}
            id="calculateButton"
          >
            Hitung
          </button>
          <br />
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col-sm-12 col-md-7">
          {error && (
            <div className="alert alert-warning">
              <b>
                <u> Terjadi Kesalahan :</u>
              </b>{" "}
              Harap isi semua kolom dengan benar.{" "}
            </div>
          )}
          {showResult &&   (
            <div
              style={{ fontSize: "16px" }}
              className="bg-light bg-gradient text-dark"
              id="resultContainer"
            >
              <div className="p-3 bg-success bg-gradient text-white">
                <strong id="resultsTitle">Hasil</strong>
              </div>
              {calculateRequiredGPA()}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
export default SharedGPAPlanner;